import React, { useEffect, useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Box, Typography } from '@material-ui/core';
import AppInput from '../../../../../../common/AppInput';
import AuthorizeCheckbox from './AuthorizeCheckbox';
import { useAuthorizeThirdStyles } from './styles';
import { schema } from './validation/schema';
import { makeInitialState, inputsInState } from './validation/initialState';
import Message from '../../../../../../common/Message';
import Loader from '../../../tracking/trackingLoading.gif';
import { authorizeThirdErrorMapper } from '../../../../../../../constants/Messages';
import {
  validateProductByMotive,
  makeSelfServiceByMotive,
} from '../../../../../../../redux/actions/TicketActions';
import {
  successCounterInState,
  validationBodyGenerator,
  dispatchGenerator,
  genericSelfServiceBody,
} from '../../../../../../../helpers/tickets/SelfService';
import { validateForm } from '../validation';
import LoadingButton from '../../../../../../common/LoadingButton';

const reducer = (state, { field, value }) => {
  if (field === 'reset') return value;
  return { ...state, [field]: value };
};

const defineCommentHelper = (name, newValue) =>
  name === 'comment' ? `${newValue.length}/250` : '';

const AuthorizeThird = ({ ...props }) => {
  const {
    mobile,
    motiveId,
    product,
    type,
    profile,
    validationStatus,
    validation,
    onData,
    selfServiceStatus,
  } = props;
  const classes = useAuthorizeThirdStyles({ mobile });
  const [valid, setValid] = useState(false);
  const [state, dispatch] = useReducer(reducer, makeInitialState());
  const [checked, setChecked] = useState(false);
  const reduxDispatch = useDispatch();

  const handleValidation = (event) => {
    validateForm(event.target, dispatch, schema, state);
  };

  const handleInputChange = (event) => {
    const { name, value: newValue } = event.target;
    const body = { newValue, helperText: defineCommentHelper(name, newValue) };
    const dispatchBody = dispatchGenerator(state, name, body);
    dispatch(dispatchBody);
  };

  const selfServiceBodyGenerator = () => ({
    ...genericSelfServiceBody({ product, profile, type, validation }),
    newRut: state['thirdId'].value,
    newName: state['thirdName'].value,
    newEmail: state['thirdEmail'].value,
  });

  const clickSelfServiceButton = () => {
    reduxDispatch(
      makeSelfServiceByMotive(motiveId, selfServiceBodyGenerator()),
    );
    onData({ motiveId, message: `${state['thirdName'].value}` });
  };

  useEffect(() => {
    setValid(successCounterInState(state));
  }, [state]);

  useEffect(() => {
    if (mobile)
      reduxDispatch(
        validateProductByMotive(motiveId, validationBodyGenerator(props)),
      );
  }, []);

  return (
    <React.Fragment>
      {validationStatus === 'validating' && (
        <Box display="flex" justifyContent="center" margin="0 auto">
          <img src={Loader} className={classes.loader} />
        </Box>
      )}
      {validationStatus === 'error' && (
        <Box className={classes.container}>
          <Message
            severity="info"
            message={authorizeThirdErrorMapper.get(validation.id)}
            fullRounded
          />
        </Box>
      )}
      {validationStatus === 'succeded' && (
        <Box className={classes.container}>
          <Typography className={classes.title}>
            Ingresa los datos de quien retira
          </Typography>
          {inputsInState.map((input, index) => (
            <AppInput
              key={index}
              name={input}
              required={state[input].required}
              helperText={state[input].helper}
              label={state[input].label}
              value={state[input].value}
              inputAdornment={state[input].inputAdornment}
              error={state[input].error}
              errorMessage={state[input].message}
              success={state[input].success}
              onClick={() => {}}
              onBlur={handleValidation}
              onChange={handleInputChange}
            />
          ))}
          <AuthorizeCheckbox
            disabled={!valid}
            onCheck={(e) => setChecked(e)}
            idComplement="AuthorizeThird"
          />
          <div className={classes.divButtonLoading}>
            <LoadingButton
              name="AuthorizeButton"
              loading={selfServiceStatus === 'loading'}
              variant="contained"
              color="primary"
              disabled={!checked}
              onClick={clickSelfServiceButton}
              text="Enviar autorización"
              className={classes.button}
              data-cy="AuthorizeButton"
            />
          </div>
        </Box>
      )}
    </React.Fragment>
  );
};

AuthorizeThird.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  product: PropTypes.object,
  type: PropTypes.string,
  profile: PropTypes.object,
  validationStatus: PropTypes.string,
  validation: PropTypes.object,
  onData: PropTypes.func,
  selfServiceStatus: PropTypes.string,
};

export default AuthorizeThird;
